import {
  type DataContextValue,
  DataProvider,
  useSingleSelectData,
} from './DataContext'
import { SearchProvider, useSingleSelectSearch } from './SearchContext'
import { StateProvider, useSingleSelectState } from './StateContext'

export {
  useSingleSelectData,
  useSingleSelectSearch,
  useSingleSelectState,
  type DataContextValue,
}

export const SingleSelectContext = {
  DataProvider,
  SearchProvider,
  StateProvider,
}
